"use client"
import { useState } from "react"
import Footer from "./Footer"

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  })

  const [formSubmitted, setFormSubmitted] = useState(false)

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    // In a real implementation, you would send the form data to a server
    console.log("Form submitted:", formData)
    setFormSubmitted(true)

    // Reset form after submission
    setFormData({
      name: "",
      email: "",
      subject: "",
      message: "",
    })

    // Reset submission status after 5 seconds
    setTimeout(() => {
      setFormSubmitted(false)
    }, 5000)
  }

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="contact-hero-container">
          <h1 className="contact-hero-title">Contact Us</h1>
          <p className="contact-hero-description">Have questions or need assistance? We're here to help!</p>
        </div>
      </section>

      {/* Contact Content */}
      <section className="contact-content-section">
        <div className="contact-content-container">
          {/* Contact Information */}
          <div className="contact-info">
            <h2 className="contact-info-title">Get in Touch</h2>
            <p className="contact-info-description">
              Our team is ready to answer your questions and provide support. Feel free to reach out through any of the
              channels below.
            </p>

            <div className="contact-methods">
              <div className="contact-method">
                <div className="method-icon">✉️</div>
                <div className="method-details">
                  <h3 className="method-title">Email</h3>
                  <p className="method-value">support@shopifyscraper.com</p>
                </div>
              </div>

              <div className="contact-method">
                <div className="method-icon">🕒</div>
                <div className="method-details">
                  <h3 className="method-title">Support Hours</h3>
                  <p className="method-value">Monday - Friday: 9am - 5pm EST</p>
                </div>
              </div>

              <div className="contact-method">
                <div className="method-icon">💬</div>
                <div className="method-details">
                  <h3 className="method-title">Live Chat</h3>
                  <p className="method-value">Available for premium users</p>
                </div>
              </div>
            </div>

            <div className="social-links">
              <h3 className="social-title">Follow Us</h3>
              <div className="social-icons">
                <a href="#" className="social-icon">
                  Facebook
                </a>
                <a href="#" className="social-icon">
                  Twitter
                </a>
                <a href="#" className="social-icon">
                  LinkedIn
                </a>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="contact-form-container">
            <h2 className="form-title">Send Us a Message</h2>

            {formSubmitted ? (
              <div className="form-success-message">Thank you for your message! We'll get back to you soon.</div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name" className="form-label">
                    Your Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="form-input"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email" className="form-label">
                    Email Address
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="form-input"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="subject" className="form-label">
                    Subject
                  </label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    className="form-input"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message" className="form-label">
                    Message
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="form-textarea"
                    rows="6"
                    required
                  ></textarea>
                </div>

                <button type="submit" className="form-submit-button">
                  Send Message
                </button>
              </form>
            )}
          </div>
        </div>
      </section>

      {/* Styling */}
      <style jsx="true">{`
        /* Contact Hero Section */
        .contact-hero {
          background-color: #007BFF;
          color: white;
          padding: 5rem 0;
          text-align: center;
        }
        
        .contact-hero-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1.5rem;
        }
        
        .contact-hero-title {
          font-size: 2.5rem;
          font-weight: 700;
          margin-bottom: 1.5rem;
        }
        
        .contact-hero-description {
          font-size: 1.25rem;
          max-width: 800px;
          margin: 0 auto;
          opacity: 0.9;
        }
        
        /* Contact Content Section */
        .contact-content-section {
          padding: 5rem 0;
          background-color: #f9fafb;
        }
        
        .contact-content-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1.5rem;
          display: flex;
          gap: 3rem;
        }
        
        /* Contact Information */
        .contact-info {
          flex: 1;
          background-color: white;
          padding: 2rem;
          border-radius: 0.5rem;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
        }
        
        .contact-info-title {
          font-size: 1.75rem;
          font-weight: 700;
          margin-bottom: 1.5rem;
          color: #1a202c;
        }
        
        .contact-info-description {
          margin-bottom: 2rem;
          color: #4a5568;
          line-height: 1.6;
        }
        
        .contact-methods {
          margin-bottom: 2rem;
        }
        
        .contact-method {
          display: flex;
          align-items: flex-start;
          margin-bottom: 1.5rem;
        }
        
        .method-icon {
          font-size: 1.5rem;
          margin-right: 1rem;
          width: 2.5rem;
          height: 2.5rem;
          background-color: #f3f4f6;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .method-details {
          flex: 1;
        }
        
        .method-title {
          font-size: 1.125rem;
          font-weight: 600;
          margin-bottom: 0.5rem;
          color: #1a202c;
        }
        
        .method-value {
          color: #4a5568;
        }
        
        .social-title {
          font-size: 1.125rem;
          font-weight: 600;
          margin-bottom: 1rem;
          color: #1a202c;
        }
        
        .social-icons {
          display: flex;
          gap: 1rem;
        }
        
        .social-icon {
          color: #4a5568;
          text-decoration: none;
          transition: color 0.2s;
        }
        
        .social-icon:hover {
          color: #007BFF;
        }
        
        /* Contact Form */
        .contact-form-container {
          flex: 1;
          background-color: white;
          padding: 2rem;
          border-radius: 0.5rem;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
        }
        
        .form-title {
          font-size: 1.75rem;
          font-weight: 700;
          margin-bottom: 1.5rem;
          color: #1a202c;
        }
        
        .form-success-message {
          background-color: #d1fae5;
          color: #065f46;
          padding: 1rem;
          border-radius: 0.375rem;
          margin-bottom: 1rem;
        }
        
        .form-group {
          margin-bottom: 1.5rem;
        }
        
        .form-label {
          display: block;
          margin-bottom: 0.5rem;
          font-weight: 500;
          color: #1a202c;
        }
        
        .form-input, .form-textarea {
          width: 100%;
          padding: 0.75rem;
          border: 1px solid #e5e7eb;
          border-radius: 0.375rem;
          font-size: 1rem;
          transition: border-color 0.2s;
        }
        
        .form-input:focus, .form-textarea:focus {
          outline: none;
          border-color: #007BFF;
          box-shadow: 0 0 0 3px rgba(0, 169, 157, 0.1);
        }
        
        .form-submit-button {
          background-color: #007BFF;
          color: white;
          border: none;
          padding: 0.75rem 1.5rem;
          border-radius: 0.375rem;
          font-weight: 600;
          cursor: pointer;
          transition: background-color 0.2s;
        }
        
        .form-submit-button:hover {
          background-color: #008f85;
        }
        
        /* Responsive Styles */
        @media (max-width: 1024px) {
          .contact-content-container {
            flex-direction: column;
          }
        }
        
        @media (max-width: 768px) {
          .contact-hero-title {
            font-size: 2rem;
          }
          
          .contact-hero-description {
            font-size: 1.125rem;
          }
          
          .contact-info-title, .form-title {
            font-size: 1.5rem;
          }
        }
      `}</style>
    </div>
  )
}

export default Contact
